

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],

      comercios_f: [],

      f_c: {

        desde: this.date_rest(this.currentdate(), -90).substring(0, 7),
        hasta: this.currentdate().substring(0, 7),
      }

    };
  },

  mounted: function () {

    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      'order': [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: ['excelHtml5']

    })
    $('.box').boxWidget()
  },

  methods: {
    consultar () {
      this.loading = true

      this.tbv.clear()

      this.$http
        .post('/SERVER/scd/reportes/', {
          'a': 'impuestos',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          this.ventast_tabla = 0
          if (response.data.status === 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              let pr = response.data.data[i][0].split('-')
              response.data.data[i][0] = pr[1] + '/' + pr[0]
              for (let d = 1; d < 32; d++) {
                response.data.data[i][d] = this.num_to_many(parseFloat(response.data.data[i][d]).toFixed(2))
              }
              this.tbv.row.add(response.data.data[i])
            }
          }

          this.tbv.draw()
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/impuestos/tventas/tventas.js